import { defineStore } from 'pinia';
import axios from 'axios';
import { somethingWentWrong, changesSaved } from '@/helpers/utilities';
import { getAxiosConfig, getAxiosConfigFormData } from '@/helpers/axiosConfigHelpers';


export const usePaymentStore = defineStore('paymentStore', () => {
    const updatePaymentMethod = async (processedForm) => {
        try {
            const response = await axios.post(
                '/api/payment/update-method',
                processedForm,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const switchSubscription = async (userId, payload) => {
        try {
            const response = await axios.post(
                `/api/payment/switch-subscription/${userId}`,
                payload,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            console.error('Error switching subscription:', error)
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const fetchPaymentInfoOfRegion = async (regionId) => {
        try {
            const response = await axios.get(
                `/api/payment-info-of-a-region/${regionId}`,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const startSubscription = async (formData) => {
        try {
            const response = await axios.post(
                `/api/payment/start-subscription`,
                formData,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            console.error('Error starting subscription:', error)
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const getSubscriptionDetails = async (userId) => {
        try {
            const response = await axios.get(
                `/api/payment/subscription-details/${userId}`,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const startZeroPaymentSubscription = async (formData) => {
        try {
            const response = await axios.post(
                `/api/payment/start-subscription/zero-payment`,
                formData,
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            console.error('Error starting zero-payment subscription:', error)
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const verifyCoupon = async (couponCode) => {
        try {
            const response = await axios.post(
                `/api/discount-coupon/verify`,
                { coupon_code: couponCode },
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            console.error('Error verifying coupon:', error)
            somethingWentWrong(error.response.data.message);
            throw error
        }
    };

    const requestCancellation = async (userId) => {
        try {
            const response = await axios.post(
                `/api/subscription/request-cancellation/${userId}`,
                {},
                getAxiosConfig()
            )
            return response;
        } catch (error) {
            console.error('Cancellation request failed:', error)
            somethingWentWrong(error.response.data.message);
            throw error
        }
    }

    return {
        // Actions
        updatePaymentMethod,
        switchSubscription,
        fetchPaymentInfoOfRegion,
        startSubscription,
        getSubscriptionDetails,
        startZeroPaymentSubscription,
        verifyCoupon,
        requestCancellation


    };
},
    {
        persist: true
    });
